module.exports = __webpack_public_path__ + "static/media/download-light.f57e43d0.svg";